import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { API } from '../../config/api';

const API_BASE = `${API.BACKEND}/api/v1/alerts`;

// Polled rather than pushed: the evaluator runs every 30s, so a faster refresh
// would only re-render the same rows. Kept short enough that a line going down
// shows up while somebody is still looking at the screen.
export function useAlerts(filters = {}) {
  return useQuery({
    queryKey: ['alerts', filters],
    queryFn: async () => (await axios.get(API_BASE, { params: filters })).data,
    refetchInterval: 20000,
    refetchOnWindowFocus: true
  });
}

export function useAlertStats(days = 30) {
  return useQuery({
    queryKey: ['alerts', 'stats', days],
    queryFn: async () => (await axios.get(`${API_BASE}/stats`, { params: { days } })).data
  });
}

export function useAckAlert() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, actor }) => axios.patch(`${API_BASE}/${id}/ack`, { actor: actor || null }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['alerts'] })
  });
}
